import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";
import { FileText, DollarSign, Package, CheckCircle, BarChart3, Users, Truck, Zap } from "lucide-react";

export function Features() {
  const features = [
    {
      icon: FileText,
      title: "Terms of Trade (ToT) Management",
      subtitle: "Manage ToT agreements from draft to analytics with automation and intelligence.",
      features: [
        "Smart templates & editable workflows",
        "Filterable ToT lists with approval options",
        "Document/email parsing to auto-create agreements",
        "Performance dashboards with combined/individual metrics",
        "AI gap analysis with actionable improvements"
      ],
      color: "bg-primary"
    },
    {
      icon: DollarSign,
      title: "Receivable Scheme Management",
      subtitle: "Seamlessly handle sell-in/sell-out schemes with transparency and control.",
      features: [
        "Advanced filters, approval workflows",
        "Real-time ledger tracking by SKU, serial, or date",
        "Custom scheme creation logic",
        "Individual and combined performance metrics",
        "Predictive AI recommendations and anomaly detection"
      ],
      color: "bg-secondary"
    },
    {
      icon: Package,
      title: "Procurement & Inventory Optimization",
      subtitle: "From PO to supplier evaluation, manage procurement with built-in intelligence.",
      features: [
        "Automated procurement workflows",
        "Inventory rollups and category insights",
        "AI-based forecasting & safety stock logic",
        "Supplier scoring, lead time prediction",
        "Integration-ready with ERP ecosystems"
      ],
      color: "bg-blue-600"
    }
  ];

  return (
    <section className="py-16 lg:py-24" style={{ backgroundColor: '#E8DDDA' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <h2 className="mb-4 text-3xl lg:text-4xl text-black font-bold">Modular, intelligent, and built for scale.</h2>
          <p className="text-lg text-muted-foreground">
            Comprehensive feature sets designed to handle every aspect of modern procurement and scheme management.
          </p>
        </div>
        
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {features.map((feature, index) => (
            <Card key={index} className="h-full">
              <CardHeader>
                <div className={`mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg ${feature.color}`}>
                  <feature.icon className="h-6 w-6 text-white" />
                </div>
                <CardTitle className="text-xl">{feature.title}</CardTitle>
                <CardDescription>{feature.subtitle}</CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3">
                  {feature.features.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start gap-3">
                      <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-secondary" />
                      <span className="text-sm">{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}